import React, {ReactElement, useEffect, useState} from 'react';
import AppBar from '../components/appbar/AppBar';
import AppFooter from '../components/appFooter/AppFooter';
import offersIcon from '../assets/images/top_nav_offers_small.svg';
import shoppingBagIcon from '../assets/images/top_nav_shopping_bag.svg';
import {useAppDispatch, useAppSelector} from '../redux/hooks';

import {useHistory, useLocation} from 'react-router-dom';
import {
  getCustomerCouponsCountinLS,
  getTotalCartItems,
} from '../core/localstorage-data';
import {setCustomerCouponsCount} from '../redux/offerSlice';
import {setCartItemsCount} from '../redux/orderSlice';
import {
  CHECKOUT_PATH,
  HOME_ROUTE_PATH,
  PAYMENT_PATH,
  SHOPPINGBAG_PATH,
  UNLOCKED_OFFERS_ROUTE_PATH,
} from '../routes/route-constants';

type CheckoutContainerProps = {
  children: React.ReactNode;
};

const CheckoutContainer: React.FC<CheckoutContainerProps> = ({
  children,
}: CheckoutContainerProps): ReactElement => {
  const navigate = useHistory();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const title = useAppSelector(state => state.globalReducer.appBarTitle);
  const backNavFunction = useAppSelector(
    state => state.globalReducer.appBarBackNavAction,
  );
  const backNavEnabled = useAppSelector(
    state => state.globalReducer.isBackNavEnabled,
  );
  const customerCouponsCount = useAppSelector(
    state => state.offerReducer.customerCouponsCount,
  );
  if (!customerCouponsCount) {
    const count = getCustomerCouponsCountinLS();
    if (count) {
      dispatch(setCustomerCouponsCount(count));
    }
  }
  const cartItemsCount = useAppSelector(
    state => state.orderReducer.cartItemsCount,
  );
  if (!cartItemsCount) {
    const totalCartItemsCount = getTotalCartItems();
    if (totalCartItemsCount) {
      dispatch(setCartItemsCount(totalCartItemsCount));
    }
  }
  function renderFooter() {
    const pathname = location.pathname;
    if (
      pathname === CHECKOUT_PATH ||
      pathname === `${CHECKOUT_PATH}${SHOPPINGBAG_PATH}`
    ) {
      return <AppFooter classNames="z-0" />;
    }
  }

  function getClassName() {
    const pathname = location.pathname;
    if (
      pathname === CHECKOUT_PATH ||
      pathname === `${CHECKOUT_PATH}${SHOPPINGBAG_PATH}`
    ) {
      return 'content-container';
    } else if (pathname === `${CHECKOUT_PATH}${PAYMENT_PATH}`) {
      return 'content-container bottom-0';
    } else {
      return 'content-container bottom-4';
    }
  }
  return (
    <div className={`absolute top-0 bottom-0 overflow-hidden left-0 right-0`}>
      <AppBar
        backButtonAction={backNavFunction}
        withDrawer={true}
        trailActions={
          <div className="grid grid-cols-2">
            <div className="relative">
              <a
                onClick={() =>
                  navigate.push(
                    `${HOME_ROUTE_PATH}${UNLOCKED_OFFERS_ROUTE_PATH}`,
                  )
                }>
                <img src={offersIcon} />
              </a>
              {customerCouponsCount > 0 && (
                <div
                  className="h-6 w-6 rounded-full absolute bottom-3 right-2 bg-red-600 text-white flex items-center justify-center"
                  onClick={() =>
                    navigate.push(
                      `${HOME_ROUTE_PATH}${UNLOCKED_OFFERS_ROUTE_PATH}`,
                    )
                  }>
                  <div>{customerCouponsCount}</div>
                </div>
              )}
            </div>
            <div className="relative">
              <a
                onClick={() =>
                  navigate.push(`${CHECKOUT_PATH}${SHOPPINGBAG_PATH}`)
                }>
                <img src={shoppingBagIcon} />
              </a>
              {cartItemsCount > 0 && (
                <div className="h-5 w-5 rounded-full absolute bottom-3 right-2 bg-red-600 text-white flex items-center justify-center">
                  <div>{cartItemsCount}</div>
                </div>
              )}
            </div>
          </div>
        }
        centerContent={title ? <b>{title}</b> : 'Self Checkout'}
        showBackNav={backNavEnabled}
      />
      {/* removed z-10 from line 65 */}
      <div
        className={`${getClassName()} bottom-16 overflow-y-scroll overflow-x-hidden left-0 right-0`}>
        {children}
      </div>
      {renderFooter()}
    </div>
  );
};

export default CheckoutContainer;
